import React, { useEffect, useState } from 'react';
import "./RatingStarStyle.css";
import { useData } from "../../Context/ContextApp"

const RatingStars = ({ rating }) => {
    let {data} = useData();
    const [ratingNumber, setRatingNumber] = useState(rating);
    const handleRatingNumber = (rating) => {
        setRatingNumber(rating);
    };

     useEffect(() => {
        let replaceRating = String(rating).replace(/\,/g, '.');
        setRatingNumber(Number(replaceRating));
     }, [rating, ratingNumber]);

    return (
        <div className={`rating_stars ${data.rtlDirection ? 'rtl' : ''}`}>
            <div className="stars-landing" id="stars-box" style={{'--rating': rating.length == 0 ? 4.5 : ratingNumber}}></div>
        </div>
    );
};

export default RatingStars;
